<template>
  <div class="w-full h-full flex flex-col bg-primary-700">
    <div class="px-4 w-full z-20 bg-primary-700">
      <router-link :to="{name:'userManagement'}" class="w-full flex items-center h-13 hov-arrow-back border-b border-solid border-primary-500">
        <i class="bg-secondary h-6 w-6 flex items-center justify-center rounded transition-200">
          <span class="icon-left text-white text-xs inline-block rounded"></span>
        </i>
        <p class="truncate text-xl sm:text-2xl md:text-3xl font-ligt pl-4">{{name}}</p>
      </router-link>
    </div>
    <div @click="isModified = true" class="h-full flex relative">
      <div :class="{'pb-12': isModified }" class="transition-200 bg-primary-700 xl:inline-block w-full h-full overflow-auto">
        <div class="px-2 py-4">
          <div class="bg-primary-800 mx-2 mb-4 px-2 py-2 rounded-lg">
             <div class="flex flex-wrap">
              <div class="flex flex-col pb-4 px-2 w-full sm:w-2/3">
                <label for="name" class="text-primary-200 text-sm pb-2">Nombre de la empresa</label>
                <Input @focus="removeName" @blur="addName" id="name" v-model="name" placeholder="Nombre del proveedor…"/>
              </div>
              <div class="flex flex-col pb-4 px-2 w-full sm:w-1/3">
                <label for="CIFNIF" class="text-primary-200 text-sm pb-2">CIF/NIF</label>
                <Input id="CIFNIF" v-model="CIFNIF" placeholder="CIF/NIF…"/>
              </div>
              <div class="flex flex-col pb-4 px-2 w-full">
                <label for="rsocial" class="text-primary-200 text-sm pb-2">Razón social</label>
                <Input id="rsocial" v-model="rsocial" placeholder="Razón social…"/>
              </div>
              <div class="flex flex-col pb-4 px-2  w-full xl:w-5/12">
                <label for="street" class="text-primary-200 text-sm pb-2">Calle</label>
                <Input id="street" v-model="street" placeholder="Calle, carretera, camino…"/>
              </div>
              <div class="flex flex-col pb-4 px-2  w-full sm:w-5/12 xl:w-3/12">
                <label for="township" class="text-primary-200 text-sm pb-2">Municipio</label>
                <Input id="township" v-model="township" placeholder="Municipio…"/>
              </div>
              <div class="flex flex-col pb-4 px-2  w-full sm:w-5/12 xl:w-3/12">
                <label for="country" class="text-primary-200 text-sm pb-2">País</label>
                <Select class="w-full" id="country" v-model="country" placeholder="País…">
                  <Option v-for="country in countries" :value="country" :key="country">
                  </Option>
                </Select>
              </div>
              <div class="flex flex-col pb-4 px-2  w-full sm:w-2/12 xl:w-1/12">
                <label for="cp" class="text-primary-200 text-sm pb-2">CP</label>
                <Input id="cp" v-model="cp" placeholder="CP…"/>
              </div>
              <div class="flex flex-col pb-4 px-2  w-full xl:w-5/12">
                <label for="email" class="text-primary-200 text-sm pb-2">Email</label>
                <Input id="email" v-model="email" placeholder="Email de contacto…"/>
              </div>
              <div class="flex flex-col pb-4 px-2  w-full sm:w-1/2 xl:w-3/12">
                <label for="tlf" class="text-primary-200 text-sm pb-2">Teléfono</label>
                <Input id="tlf" v-model="tlf" placeholder="Teléfono de contacto…"/>
              </div>
              <div class="flex flex-col pb-4 px-2  w-full sm:w-1/2 xl:w-4/12">
                <label for="tlf2" class="text-primary-200 text-sm pb-2">Teléfono secundario</label>
                <Input id="tlf2" v-model="tlf2" placeholder="Segundo teléfono de contacto…"/>
              </div>
            </div>
          </div>
          <Collapse>
            <Collapse-item title="Personas de contacto" name="contacto">
              <div class="flex items-center px-2" :class="{'pointer-events-none , opacity-25':addContactOpened}">
                <Table
                  ref="multipleTable"
                  :data="amountsData"
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
                  <TableColumn
                    type="selection"
                    width="40">
                  </TableColumn>
                  <TableColumn
                    sortable
                    property="name"
                    label="Nombre"
                    width="250">
                  </TableColumn>
                  <TableColumn
                    sortable
                    property="position"
                    label="Cargo"
                    width="150">
                  </TableColumn>
                  <TableColumn
                    sortable
                    property="email"
                    label="Email"
                    width="250">
                  </TableColumn>
                  <TableColumn
                    sortable
                    property="phone"
                    label="Teléfono"
                    width="150">
                  </TableColumn>
                </Table>
              </div>
              <div class="flex flex-wrap xl:flex-no-wrap items-end z-50">
                <transition name="modal-fade-down">
                  <div v-if="addContactOpened" class="flex flex-col px-2 pt-4 w-full sm:w-1/2 md:w-1/3 xl:w-full">
                    <Input id="newContactName" v-model="newContactName" placeholder="Nombre y apellidos…"/>
                  </div>
                </transition>
                <transition name="modal-fade-down">
                  <div v-if="addContactOpened" class="flex flex-col px-2 pt-4 w-full sm:w-1/2 md:w-1/3 xl:w-full">
                    <Input id="newContactPosition" v-model="newContactPosition" placeholder="Cargo/puesto…"/>
                  </div>
                </transition>
                <transition name="modal-fade-down">
                  <div v-if="addContactOpened" class="flex flex-col px-2 pt-4 w-full sm:w-1/2 md:w-1/3 xl:w-full">
                    <Input id="newContactEmail" v-model="newContactEmail" placeholder="Email de contacto…"/>
                  </div>
                </transition>
                <transition name="modal-fade-down">
                  <div v-if="addContactOpened" class="flex flex-col px-2 pt-4 w-full sm:w-1/2 xl:w-full">
                    <Input id="newContactPhone" v-model="newContactPhone" placeholder="Teléfono de contacto…"/>
                  </div>
                </transition>
                <div class="w-full md:w-1/2 xl:w-full pt-4 px-2 ml-auto flex">
                  <Button :class="{'w-full': addContactOpened}" v-if="!contactPeopleSelected" @click="addContact()" class="w-auto truncate" type="primary" icon="el-icon-plus" style="margin-left:auto">Añadir <span v-if="!addContactOpened">persona de contacto</span></Button>
                  <Button v-if="!contactPeopleSelected && addContactOpened" @click="addContact()" class="w-full truncate" type="info" icon="el-icon-close">cancelar</Button>
                  <Button v-if="contactPeopleSelected" @click="removeContact()" class="w-full truncate" type="danger" icon="el-icon-delete">Eliminar</Button>
                </div>
              </div>
            </Collapse-item>
          </Collapse>
          <Collapse>
            <Collapse-item title="Comentarios" name="comentarios">
            <!-- INICIO COMENTARIO -->
              <div class="w-full py-3 text-base">
                <div class="flex items-center">
                  <div class="h-8 w-8 overflow-hidden rounded-full ml-2">
                    <img class="transition-200" src="~@/assets/img/test-user.png" alt="">
                  </div>
                  <div class="pl-2">
                    <div class="flex text-light leading-tight">
                      <p class="font-medium">Richard Tomás</p>
                      <span class="px-2">·</span>
                      <p class="font-light">Contabilidad</p>
                    </div>
                    <p class="text-xs text-primary-200">martes, 24 de septiembre de 2019 10:49</p>
                  </div>
                </div>
                <div class="w-full px-2">
                  <div class="bg-primary-700 w-full p-4 mt-2 rounded-r-lg rounded-b-lg text-primary-200">
                    Mi comentario es todo ok
                  </div>
                </div>
              </div>
            <!-- FIN COMENTARIO -->
              <div class="flex flex-wrap lg:flex-no-wrap items-end z-50 pt-4">
                <transition name="modal-fade-down">
                  <div v-if="addCommentOpened" class="px-2 w-full">
                    <Input id="Comment" v-model="Comment" placeholder="Escriba aquí su comentario…"/>
                  </div>
                </transition>
                <div class="px-2 w-auto ml-auto min-w-60 pt-2">
                  <Button  @click="addComment()" class="truncate w-full" type="primary" icon="el-icon-plus"><span v-if="!addCommentOpened">Añadir comentario</span> <span v-if="addCommentOpened">Comentar</span></Button>
                </div>
              </div>
            </Collapse-item>
          </Collapse>
        </div>
      </div>
    </div>
    <div class="w-full absolute bottom-0 right-0 overflow-hidden transition-200 flex items-center px-4 global bg-primary-800 z-10" :class="[isModified ? 'h-12':'h-0']">
      <div class="ml-auto">
        <Button @click="isModified = !isModified" type="primary" size="small" icon="el-icon-check">Guardar cambios</Button>
      </div>
    </div>
  </div>
</template>
<script>
import { Input, Select, Option, Button, Table, TableColumn, CollapseItem, Collapse } from 'element-ui'
export default {
  components: {
    CollapseItem,
    Collapse,
    Select,
    Option,
    Button,
    Input,
    Table,
    TableColumn
  },
  data () {
    return {
      url: 'https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK',
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      name: 'Nuevo proveedor',
      amountsData: [{
        name: 'María Cepeda',
        position: 'CTO',
        email: 'mcepeda@bibendum.com',
        phone: '987654321'
      }, {
        name: 'Richard Tomás',
        position: 'Contabilidad',
        email: 'rtomas@dolimse.com',
        phone: '654321987'
      }],
      CIFNIF: '',
      rsocial: '',
      street: '',
      township: '',
      cp: '',
      email: '',
      tlf: '',
      tlf2: '',
      newContactName: '',
      newContactPosition: '',
      newContactEmail: '',
      newContactPhone: '',
      Comment: '',
      country: 'Seleccione…',
      countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia & Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre & Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts & Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', "Timor L'Este", 'Togo', 'Tonga', 'Trinidad & Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks & Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'],
      isModified: false,
      addContactOpened: false,
      contactPeopleSelected: false,
      addCommentOpened: false
    }
  },

  methods: {
    urlUpdated (url) {
      this.documentError = undefined
      this.url = url
    },
    onDocumentErrored (e) {
      this.documentError = e.text
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (Object.keys(this.multipleSelection).length > 0) {
        this.contactPeopleSelected = true
      } else {
        this.contactPeopleSelected = false
      }
    },
    removeName () {
      if (this.name === 'Nuevo proveedor' || this.name === 'Nombre del proveedor') {
        this.name = ''
      }
    },
    addName () {
      if (this.name === '') {
        this.name = 'Nombre del proveedor'
      }
    },
    addContact () {
      this.addContactOpened = !this.addContactOpened
    },
    addComment () {
      this.addCommentOpened = !this.addCommentOpened
    }
  }
}
</script>
